'use client'
import { technologiesConst } from '@/constant/const'
import React from 'react'
import { useRouter } from 'next/navigation'
import Link from 'next/link'

function TechnologiesList() {
   const router = useRouter()

   // Map technology names to their corresponding URL paths
   const techPathMap = {
      // Frontend
      'Vue JS': '/technologies/frontend/vuejs-application-development-company',
      'React JS': '/technologies/frontend/react-development-company',
      'Angular JS': '/technologies/frontend/angular-development-company',
      'Next JS':
         '/technologies/frontend/next-js-application-development-company',
      TypeScript: '/technologies/frontend/typescript-development-company',

      // Backend
      PHP: '/technologies/backend/php-application-development-company',
      Python: '/technologies/backend/python-development-company',
      Laravel: '/technologies/backend/laravel-application-development-company',
      'Node JS': '/technologies/backend/nodejs-application-development-company',
      'ASP.NET': '/technologies/backend/aspdotnet-development-company',
      JAVA: '/technologies/backend/java-application-development-company',
      CodeIgniter: '/technologies/backend/codeigniter-development-company',

      // Mobile
      IOS: '/technologies/mobile/ios-application-development-company',
      Android: '/technologies/mobile/android-application-development-company',
      Flutter: '/technologies/mobile/flutter-development-company',
      'React Native': '/technologies/mobile/react-native-development-company',

      //
      'Project & Management': '/technologies/project-management',
   }

   const openCalendly = () => {
      if (typeof window !== 'undefined' && window.Calendly) {
         window.Calendly.initPopupWidget({
            url: 'https://calendly.com/brijesh-vadukia/let-s-schedule-a-meeting',
         })
      } else {
         console.error('Calendly script not loaded yet.')
      }
   }

   // Function to handle technology item click
   const handleTechItemClick = (techCategory, techName) => {
      console.log('techCategory', techCategory)
      // Check if we have a direct mapping for this technology
      if (techPathMap[techName]) {
         // Navigate to the technology page
         return techPathMap[techName]
      }
      return '#'
   }

   return (
      <section className=" section_secondary_bg">
         <div className="container  tech_tab text-center">
            <div className="text-center mb-2">
               <h1 className="tech_title section_heading_title mb-0">
                  Technologies & Platforms We Work With
               </h1>
               <div className="d-flex justify-content-center">
                  <p className="tech_body">
                     We excel in a diverse range of cutting-edge technologies,
                     driving innovation and success with tailored solutions that
                     transform businesses.
                  </p>
               </div>
            </div>
            <div className="tech-tabs">
               <nav className="nav">
                  {technologiesConst.map((tech, index) => (
                     <button
                        key={tech.id}
                        className={`nav-link ${index === 0 ? 'active' : ''}`}
                        data-bs-toggle="tab"
                        data-bs-target={`#${tech.id}`}
                     >
                        {tech.name}
                     </button>
                  ))}
               </nav>

               <div className="tab-content">
                  {technologiesConst.map((tech, index) => (
                     <div
                        key={tech.id}
                        className={`tab-pane fade ${
                           index === 0 ? 'show active' : ''
                        }`}
                        id={tech.id}
                     >
                        <div className="tech-grid">
                           {tech.items.map((item, i) => (
                              <Link
                                 href={item.href || '#'}
                                 key={i}
                                 className="tech-item"
                                 style={{
                                    cursor: item.href ? 'pointer' : 'default',
                                 }}
                              >
                                 <img src={item.image} alt={item.alt} />
                                 <p>{item.name}</p>
                              </Link>
                           ))}
                        </div>
                     </div>
                  ))}
               </div>
            </div>
            <div className="btn bez-fill-btn mt-4" onClick={openCalendly}>
               Schedule a Developer Interview
               <svg
                  width="37"
                  className="img-fluid"
                  height="37"
                  viewBox="0 0 37 37"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
               >
                  <g clipPath="url(#clip0_5116_214025)">
                     <path
                        d="M36.2699 17.749L28.0882 9.56725C27.7943 9.22406 27.2778 9.18405 26.9347 9.47803C26.5915 9.77193 26.5515 10.2884 26.8454 10.6316C26.8729 10.6637 26.9026 10.6934 26.9347 10.7208L33.7172 17.5117H1.32595C0.874134 17.5117 0.507812 17.878 0.507812 18.3299C0.507812 18.7818 0.874134 19.148 1.32595 19.148H33.7172L26.9347 25.9306C26.5915 26.2245 26.5515 26.741 26.8454 27.0842C27.1394 27.4274 27.6558 27.4674 27.999 27.1734C28.0311 27.1459 28.0608 27.1162 28.0882 27.0842L36.2699 18.9025C36.5871 18.5835 36.5871 18.0681 36.2699 17.749Z"
                        fill="#F4F2F0"
                     />
                  </g>
                  <defs>
                     <clipPath id="clip0_5116_214025">
                        <rect
                           width="36"
                           height="36"
                           fill="white"
                           transform="translate(0.507812 0.324219)"
                        />
                     </clipPath>
                  </defs>
               </svg>
            </div>
         </div>
      </section>
   )
}

export default TechnologiesList
